import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { SelecionarExtratoEstoque, SelecionarExtratoEstoqueDetalhe, FiltroExtratoEstoqueDetalhe } from 'src/app/@shared/models/extrato-estoque.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class ExtratoEstoqueService {

  constructor(private http: HttpClient) { }

  selecionarExtratoEstoque(obj?: any): Observable<HttpResponse<SelecionarExtratoEstoque[]>> {
    return this.http.post<SelecionarExtratoEstoque[]>(
      `EstoqueExtrato/SelecionarExtratoEstoque`,
      obj,
      { observe: 'response' }
    );
  }

  selecionarExtratoEstoqueDetalhe(filtro: FiltroExtratoEstoqueDetalhe):
    Observable<HttpResponse<SelecionarExtratoEstoqueDetalhe[]>> {
    return this.http.post<SelecionarExtratoEstoqueDetalhe[]>(
      `EstoqueExtrato/SelecionarExtratoEstoqueDetalhe`,
      filtro,
      { observe: 'response' }
    );
  }
}
